module.exports = ".flexed {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.top-margin {\n  margin-top: 2%;\n}\n.scrollable {\n  overflow: scroll;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stats/dashboard/dashboard.component.css
// module id = ./src/app/modules/stats/dashboard/dashboard.component.css
// module chunks = main